import Clipboard from 'clipboard'

export const newClipboard = (action, data) => {
  const clipboard = new Clipboard(action, {
    text: function (trigger) {
      return data
    }
  })
  clipboard.on('error', (e) => {
    console.log('Action:', e.action)
    console.log('Trigger:', e.trigger)
  })
}

export default {
  newClipboard
}
